import { CALL_HISTORY_METHOD } from 'Config/types';

export const updateLocation = (method) => (args) => ({
  type: CALL_HISTORY_METHOD,
  payload: { method, ...args },
});

/**
 * These actions correspond to the history API.
 * the associated routerMiddleware will capture these events before they
 * get to the reducer and reissue them as matching functions on your history.
 */
export const push = updateLocation('push');
export const replace = updateLocation('replace');
export const go = updateLocation('go');
export const goBack = updateLocation('goBack');
export const goForward = updateLocation('goForward');

export const routerActions = { push, replace, go, goBack, goForward };



// WEBPACK FOOTER //
// ./app/actions/router.js